import { QueryResourcesInfinite } from 'datx-jsonapi-react';

import { ICollectionMeta } from '@/interfaces/ICollectionMeta';
import { ChatMessages } from '@/resources/ChatMessages';

export const queryAllChatMessages = (channelId: string): QueryResourcesInfinite<ChatMessages> => {
  if (!channelId) return null;

  return (pageIndex, previousPageData) => {
    const meta = previousPageData?.meta as ICollectionMeta;
    const pageCursor = meta?.pageCursor;

    if (previousPageData && pageCursor === null) {
      return null;
    }

    const pageNumber = pageIndex + 1;

    return [
      ChatMessages.type,
      {
        filter: {
          channel_id: channelId,
        },
        sort: '-createdAt',
        params: [
          {
            key: 'page[size]',
            value: '14',
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
          {
            key: 'page[cursor]',
            value: pageCursor || '',
          },
        ],
      },
    ];
  };
};
